export const categories = [
  {
    slug: "jingji-saishi",
    name: "竞技赛事",
    description: "高强度的电竞对抗赛，展现你的操作与战术",
    icon: "ri-sword-line",
    articleCount: 42,
  },
  {
    slug: "xiuxian-tiaozhan",
    name: "休闲挑战",
    description: "轻松有趣的每日小游戏，随时随地参与",
    icon: "ri-gamepad-line",
    articleCount: 35,
  },
  {
    slug: "zhishi-jingsai",
    name: "知识竞赛",
    description: "头脑风暴知识比拼，用智慧赢取大奖",
    icon: "ri-lightbulb-line",
    articleCount: 28,
  },
  {
    slug: "tuandui-lianmeng",
    name: "团队联盟",
    description: "组队参赛，与好友一起冲击排行榜",
    icon: "ri-team-line",
    articleCount: 31,
  },
  {
    slug: "xinren-zhuanshu",
    name: "新人专属",
    description: "专为新玩家打造的入门赛事，轻松上手",
    icon: "ri-star-line",
    articleCount: 19,
  },
  {
    slug: "gaoji-jingji",
    name: "高级竞技",
    description: "顶尖玩家的巅峰对决，争夺最高荣誉",
    icon: "ri-trophy-line",
    articleCount: 24,
  },
];